export default {
  taskAssignment: {
    title: 'تخصیص وظایف',
    subtitle: 'مدیریت و تخصیص وظایف نصب به نصب کنندگان',
    installers: 'تسک های کاربران',
    unassignedInstallations: 'تسک های تخصیص نیافته',
    searchInstallers: 'جستجوی تسک ها...',
    searchInstallations: 'جستجوی کارمندان...',
    tasksCount: 'تسک ها: {count}',
    dragHint: 'برای تخصیص، تسک را بکشید',
    taskDetails: 'جزئیات وظیفه',
    tasks: 'وظایف و بار کاری',
    taskAssigned: 'وظیفه با موفقیت تخصیص داده شد',
    taskUnassigned: 'وظیفه با موفقیت لغو تخصیص شد',
    assignFailed: 'تخصیص وظیفه با خطا مواجه شد. لطفاً دوباره تلاش کنید.',
    unassignFailed: 'لغو تخصیص وظیفه با خطا مواجه شد. لطفاً دوباره تلاش کنید.',
    noInstallersFound: 'نصب کننده ای یافت نشد',
    noInstallationsFound: 'نصبی یافت نشد'
  },
  installerTasks: {
    filterStatus: 'وضعیت',
    status: {
      assigned: 'تخصیص داده شده',
      inProgress: 'در حال انجام',
      completed: 'تکمیل شده',
      cancelled: 'لغو شده',
    },
  },
}
